import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { ConfigData } from "../model/data/ConfigData";
import { GameUpdateData } from "../model/data/GameUpdateData";
import { RecoveryData } from "../model/data/RecoveryData";
import { TicketData } from "../model/data/TicketData";
import { SlingoConstants } from "../model/enum/SlingoConstants";
/**
 * CurrentGameResponseData.ts
 */
export class CurrentGameResponseData extends SolidifyableData {
    constructor(data) {
        super(data);
    }
    solidify() {
        super.solidify();
        if (this.isSuccess()) {
            this.solidifyConfig();
            this.solidifyTicket();
            this.solidifyGameUpdate();
            this.solidifyRecovery();
        }
    }
    solidifyConfig() {
        let config = this.data.getDataObject(SlingoConstants.PROPERTY_CONFIG);
        if (this.dataExists(config)) {
            this.config = new ConfigData(config);
        }
    }
    solidifyTicket() {
        let ticketData = this.data.getDataObject(SlingoConstants.PROPERTY_TICKET);
        if (this.dataExists(ticketData)) {
            this.ticket = new TicketData(ticketData);
        }
    }
    solidifyGameUpdate() {
        if (this.dataExists(this.data)) {
            this.gameUpdate = new GameUpdateData(this.data);
            if (this.gameUpdate.hasFreeGame()) {
                this.updateStake(this.gameUpdate.getFreeGameStake());
            }
            else if (this.gameUpdate.hasLastStake()) {
                this.updateStake(this.gameUpdate.getLastStake());
            }
        }
    }
    solidifyRecovery() {
        let recoveryData = this.data.getDataObject(SlingoConstants.PROPERTY_RECOVERY);
        if (this.dataExists(recoveryData)) {
            this.recovery = new RecoveryData(recoveryData);
            this.updateStake(this.recovery.getStakeAmount());
        }
    }
    updateStake(value) {
        let stakeConfig = this.config.getStakeConfig();
        stakeConfig.setIndexByAmount(value);
    }
    getGameUpdate() {
        return this.gameUpdate;
    }
    getConfig() {
        return this.config;
    }
    getTicket() {
        return this.ticket;
    }
    getRecovery() {
        return this.recovery;
    }
    isRecovery() {
        return !this.gameUpdate.getState().isPurchaseEntry();
    }
}
//# sourceMappingURL=CurrentGameResponseData.js.map